import { render, staticRenderFns } from "./BlockFeaturedEntry.vue?vue&type=template&id=f0956686&"
import script from "./BlockFeaturedEntry.vue?vue&type=script&lang=js&"
export * from "./BlockFeaturedEntry.vue?vue&type=script&lang=js&"
import style0 from "./BlockFeaturedEntry.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports